<template>
  <div>
      <BaseInputWithContextMenu
        :ref="'contextMenuBaseForRichEdit_' + inputElementId"
        :target-id="inputElementId"
        :is-read-only="isReadOnlyState"
        :value="Value"
        :control="$attrs.control"
        :additional-menu-items="additionalMenuItems"
        :enable-speech-features="true"
        :enable-system-options="true"
        @input="onEditorInput"
        @control-changed="setChangedStatus"
        @context-menu-select="handleContextMenuSelect"
        :is-ckeditor="true"
      >
        <ckeditor
          ref="ckeditorInstance" 
          v-b-tooltip.hover :title="Hint"
          v-model="Value" 
          :config="editorConfig"
          :disabled="this.$attrs.control.isReadOnly || NoteIsVoid || this.isReadOnly"
          :read-only="this.$attrs.control.isReadOnly || NoteIsVoid || this.$attrs.control.IsChartReview || this.isReadOnly"
          @input="onEditorInput"
          @blur="onEditorBlur"
          :editor-url="editorUrl"
          v-bind:style="style"
          :class="componentClass"
          @ready="onEditorReady"
          :id="inputElementId">
        </ckeditor>
    </BaseInputWithContextMenu>

    <MdPatientDiagCodes v-if="activateModalDiagCodes"
      v-bind:ModalId="controlID"
      v-bind:TitleWindow="outComeTitle"
      v-bind:DateFrom="this.DateFrom"
      @getCodeConditionOK="onCodeConditionOk($event)"
      @getCancel="onCancel($event)"
    ></MdPatientDiagCodes>
    <MdPatientInsurances v-if="activateModalInsurance"
      v-bind:ModalId="controlID"
      v-bind:TitleWindow="outComeTitle"
      @getCodeConditionOK="onCodeConditionOk($event)"
      @getCancel="onCancel($event)"
    ></MdPatientInsurances>
    <MdPatientContacts v-if="activateModalContacts"
      v-bind:ModalId="controlID"
      v-bind:TitleWindow="outComeTitle"
      @getCodeConditionOK="onCodeConditionOk($event)"
      @getCancel="onCancel($event)"
    ></MdPatientContacts>
    <MdPatientAllergiesOutCome v-if="activateModalAllergies"
      v-bind:ModalId="controlID"
      v-bind:AdmissionRecordId="this.$route.params.recordid"
      v-bind:PatientCode="this.$route.params.id"
      v-bind:TitleWindow="outComeTitle"
      @getCodeConditionOK="onCodeConditionOk($event)"
      @getCancel="onCancel($event)"
    ></MdPatientAllergiesOutCome>
    <MdGenericOutCome v-if="activateModalGeneric"
      v-bind:ModalId="controlID"
      v-bind:TitleWindow="outComeTitle"
      v-bind:outComeCode="outComeCode"
      v-bind:outComeDescription="outComeDescription"
      @getCodeConditionOK="onCodeConditionOk($event)"
      @getCancel="onCancel($event)"
    ></MdGenericOutCome>
    <MdPainAssessmentNotesOutCome v-if="activeModalPainAssessment"
      v-bind:ModalId="controlID"
      v-bind:TitleWindow="outComeTitle"
      v-bind:outComeCode="outComeCode"
      @getCodeConditionOK="onCodeConditionOk($event)"
      @getCancel="onCancel($event)"
    ></MdPainAssessmentNotesOutCome>
    <MdPatientVitalSingOutCome v-if="activeModalVitalSign"
      v-bind:ModalId="controlID"
      v-bind:TitleWindow="outComeTitle"
      v-bind:outComeCode="outComeCode"
      v-bind:ComponentKind="'RichEdit'"
      @getCodeConditionOK="onCodeConditionOk($event)"
      @getCancel="onCancel($event)"
    ></MdPatientVitalSingOutCome>
    <MdGetLastAnswers v-if="showGetLastAnswers"
      @getCancel="onCancelGetLastAnswers($event)"
      @getOK="onOKGetLastAnswers($event)"
      v-bind:ControlId="controlID"
      v-bind:PatientCode="PatientCode"
      v-bind:TransDate="TransDate"
    />
    <MdPatientMedicationsOutCome v-if="activateModalMedications"
      v-bind:ModalId="controlID"
      v-bind:PatientCode="this.PatientCode"
      v-bind:TitleWindow="outComeTitle"
      @getCodeConditionOK="onCodeConditionOk($event)"
      @getCancel="onCancel($event)"
    ></MdPatientMedicationsOutCome>
    <!-- <MdTextSpeech></MdTextSpeech> -->
  </div>
</template>

<script>
  import Utils from '@/common/utils.js'
  import { EventBus } from '../../event-bus.js';
  import GlobalService from '@/services/global.service'
  import Vue from 'vue';
  import { ContextMenuPlugin } from "@syncfusion/ej2-vue-navigations";

  Vue.use(ContextMenuPlugin);
  export default {
    mixins: [EventBus],
    props: {     
     MaxRows: String,
     Rows: String,
     MaxLength: String,
     isReadOnly:Boolean,
     value:[String],
     Name:String,
     Placeholder:String,
     TransDate: String,
     NoteId: String,
     DateFrom:String,
     id: [String, Number],
     HideToolBar: Boolean,
     PatientCode: String,
     IsCommonPart: Boolean,
     IsGroupContainer: Boolean
   },
    data() {
      return {
         Value: this.value,
          NoteIsVoid:false,        
         style: {
          border: 'solid 1px #e0e0e0 !important',
          position:'absolute',
          top: this.$attrs.control.controlTop+'px',          
          left:this.$attrs.control.controlLeft+'px',
          borderColor: '#e0e0e0 !important',
          textAlign:'',         
          borderRadius: '5px',
        },
         Hint: this.$attrs.control.controlHint,
         controlID:String(this.$attrs.control.controlID),
         outComeDescription: Utils.strToTitleCase(this.$attrs.control.outComeDescription),
         outComeTemplateCode:this.$attrs.control.outComeTemplateCode,
         outComeTitle: Utils.strToTitleCase(this.$attrs.control.outComeDescription),
         outComeCode:this.$attrs.control.outComeCode,
         Invalid:false,
         isRequired: this.$attrs.control.isRequired,
         activateModalInsurance:false,
         activateModalContacts:false,
         activateModalDiagCodes:false,
         activateModalAllergies:false,
         activateModalGeneric:false,
         activeModalPainAssessment:false,
         activeModalVitalSign:false,
         showGetLastAnswers: false,
         activateModalMedications: false,
         //PatientCode: this.$route.params.id,
         menuItems:[],
         targetId: "target-"+this.$attrs.HeaderId+"-"+this.$attrs.control.controlID,
         menuTargetId:"#target-"+this.$attrs.HeaderId+"-"+this.$attrs.control.controlID,
         //componentClass: this.$attrs.control.outComeCode ? 'outcome' : 'cursor-context-menu',
          componentClass: this.$attrs.control.outComeCode ? 'cutescroll cursor-context-menu outcome' : 'cutescroll cursor-context-menu',
         editorUrl: '/ckeditor/ckeditor.js',
         isLoadingCkeditor: true,
         editorConfig: {
          controlId: this.$attrs.control.controlID,
          noteId: this.NoteId,
          hideTB: this.HideToolBar || this.$attrs.control.isReadOnly || this.$attrs.control.controlHeight < 100,
          bodyId: 'ckeditorBody'+this.$attrs.control.controlID,
          ckHeight: "",
          on: {
                instanceReady : function ( evt )
                {
                  document.getElementById( `${evt.editor.id}_top` ).style.display = 'none';

                  if (evt.editor.config.readOnly) {
                    document.getElementById( `${evt.editor.id}_contents` ).style.backgroundColor = 'rgb(233, 236, 239)';
                  }
                    
                },

                beforeCommandExec: async function(evt) {
                  if (evt.data.name == 'toolbarCollapse') {
                    evt.editor.config.ckHeight = evt.editor.container.$.offsetHeight
                  }
                },

                afterCommandExec: async function(evt) {
                  if (evt.data.name == 'toolbarCollapse') {
                    evt.editor.resize(evt.editor.container.$.offsetWidth, evt.editor.config.ckHeight);
                  }
                },

                focus: async function(evt) {
                  if (!evt.editor.config.hideTB) {
                    document.getElementById( `${evt.editor.id}_top` ).style.display = null;
                    evt.editor.resize(evt.editor.container.$.offsetWidth, evt.editor.config.height);
                  }
                },

                blur: async function(evt) {
                  document.getElementById( `${evt.editor.id}_top` ).style.display = 'none';
                  evt.editor.resize(evt.editor.container.$.offsetWidth, evt.editor.config.height);
                },

                paste: async function(evt) {
                  let rtfData = evt.data.dataTransfer.getData( 'text/rtf', true);
                  const filesCount = evt.data.dataTransfer.getFilesCount()
                  const textData = evt.data.dataTransfer.getData( 'Text', true);
                  const htmlData = evt.data.dataTransfer.getData( 'text/html', true);
                  let rtfContent= { rtf:[] }
                  if(!textData && !htmlData && filesCount > 0){
                    let imagen = evt.data.dataTransfer.getFile(0);
                    let reader = new FileReader();
                    reader.onload = function(e) {
                      let element = evt.editor.document.createElement('img', {
                        attributes: {
                          src: e.target.result
                        }
                      });
                      evt.editor.insertElement(element);             
                    };
                    reader.readAsDataURL(imagen);
                  }

                  if(filesCount == 0 && rtfData && !htmlData){
                    evt.cancel();
                    rtfData = rtfData.replaceAll(/\\\*\\fldinst HYPERLINK .*"/g,'');
                    rtfData = rtfData.replaceAll('>', '');
                    rtfData = rtfData.replaceAll('<', '');
                    rtfContent.rtf[0] = rtfData
                    await GlobalService.RtfToHtml(rtfContent)
                      .then(( response) => {
                        if(response.status == '200'){
                            this.htmlContent = response.data.html[0];
                            evt.editor.insertHtml(this.htmlContent);
                        }
                      })
                      .catch((error) => {
                        if(error.response) {
                          evt.cancel();
                        }
                      });
                  }
                  var changed = {
                    "ControlId":this.config.controlId,
                    "Changed":true,
                    "NoteId":this.config.noteId
                  }
                  EventBus.$emit('onControlWasChanged', changed);
                }
              },
          title: false, 
          toolbar: [ 
            {
              name: 'basicstyles',
              items: ['Bold','Italic','Underline','Strike','-','NumberedList','BulletedList','-','Outdent','Indent','-',
                      'JustifyLeft','JustifyCenter','JustifyRight','JustifyBlock','-','Link','Unlink','-','Table','Image']
            },
            {
              name: 'format',
              items: ['Styles','Format','Font','FontSize','TextColor','BGColor']
            },
          ],
          width: this.$attrs.control.controlWidth,
          height: this.$attrs.control.controlHeight,
          extraPlugins: 'tableresize,divarea',
          removePlugins: 'save,smiley,forms,flash,templates,print,preview,iframe,find,exportpdf,\
                          specialchar,pagebreak,wsc,scayt,liststyle,div,a11yhelp,\
                          about,language,indentblock,bidi,removeformat,sourcearea,\
                          maximize,htmlwriter,horizontalrule,showblocks,\
                          blockquote,copyformatting,selectall,newpage,elementspath,resize',
          removeButtons: 'Subscript,Superscript,Cut,Copy,PasteText,PasteFromWord',
          readOnly: this.$attrs.control.isReadOnly || this.NoteIsVoid || this.isReadOnly,
          enterMode: 2,
          shiftEnterMode: 2
         }
      }
    },

    watch: {
        value: {
          immediate: true,
          handler: function(newModel) {
            this.Value = newModel;
          }
        }
    },
    computed: {
      inputElementId() {
        return this.$attrs.HeaderId + '-' + this.$attrs.control.controlID;
      },
      
      isReadOnlyState() {
        return this.$attrs.control.isReadOnly || this.NoteIsVoid || this.$attrs.control.IsChartReview || this.isReadOnly;
      },
      
      additionalMenuItems() {
        const items = [];
        if (!this.IsCommonPart) {
          items.push({ text: this.$t('ContextMenu.GetLast10'), id: "gettenlastans" });
        }
        if(this.outComeDescription) {
          items.push({text: this.outComeDescription, id: "outcome"})
        }
        return items;
      },
      enableSpeechFeatures() {
        // Example: Do not enable speech in numeric fields
        const controlDataType = this.$attrs.control.controlDataType;
        return controlDataType !== 'Integer' && controlDataType !== 'Money';
      },
      enableSystemOptions() {
          // Example: Do not enable speech in numeric fields
          const controlDataType = this.$attrs.control.controlDataType;
          return controlDataType !== 'Integer' && controlDataType !== 'Money';
      }
  },
  methods:{

     deActivateModal(){
       if(this.outComeTemplateCode.toUpperCase() === 'TFRMMDPATIENTCONTACTS')
       this.activateModalContacts = false
      else if(this.outComeTemplateCode.toUpperCase() === 'TFRMPATIENTINSURANCES')
       this.activateModalInsurance = false
      else if(this.outComeTemplateCode.toUpperCase() === 'TFRMPATIENTDIAGCODES')
       this.activateModalDiagCodes = false
      else if(this.outComeTemplateCode.toUpperCase() === 'TFRMALLERGIESEHR')
       this.activateModalAllergies = false
      else if(this.outComeTemplateCode.toUpperCase() === 'TFMMDNOTEOUTCOMESTUDIES')
       this.activateModalGeneric = false
      else if(this.outComeTemplateCode.toUpperCase() === 'TFRMMDPAINASSESSMENTNOTES')
       this.activeModalPainAssessment = false
      else if(this.outComeTemplateCode.toUpperCase() === 'TFRMMDVITALSIGNSNOTES')
       this.activeModalVitalSign = false
      else if(this.outComeTemplateCode.toUpperCase() === 'TFRMCUSTOMPATIENTMEDICATIONS')
        this.activateModalMedications = false
     },

     onCancel(){
       this.deActivateModal()
     },

     onEditorInput(value){
      this.$emit('input',value);
      if (!this.isLoadingCkeditor) {
        this.Invalid = value.length == 0 && this.$attrs.control.isRequired ? true : false;
        this.style.borderColor = this.Invalid ? '#dc3545 !important': '#e0e0e0 !important'
        this.setChangedStatus()
      }
     },

     onCodeConditionOk(result) {
       if(result) {
          this.Value = result;
          this.$emit('input',result);
          this.setChangedStatus()
       }
       this.deActivateModal()
     },

       InitializeVariables(){
      // this.style.backgroundColor = this.$attrs.control.isReadOnly ? '#e9ecef !important' :'';
        if(this.$attrs.control.isReadOnly || this.isReadOnly){
         // this.style.backgroundColor = '#dfe4eb !important';
         this.style.backgroundColor = '#e9ecef !important';
        }else{
           this.style.backgroundImage = 'linear-gradient(130deg, white, rgb(241, 253, 255))';
        }
       },

     onEditorBlur(){
       this.$emit('blur',this.Value)
       this.Invalid = this.Value.length == 0 && this.isRequired ? true : false;
       this.style.borderColor = this.Invalid ? '#dc3545 !important': '#e0e0e0 !important'
     },

     ChangeValue(value) {
        this.onEditorInput(value);
     },

    showModal() {
      if(this.outComeTemplateCode.toUpperCase() === 'TFRMMDPATIENTCONTACTS')
       this.activateModalContacts = true
      else if(this.outComeTemplateCode.toUpperCase() === 'TFRMPATIENTINSURANCES')
       this.activateModalInsurance = true
      else if(this.outComeTemplateCode.toUpperCase() === 'TFRMPATIENTDIAGCODES')
       this.activateModalDiagCodes = true
      else if(this.outComeTemplateCode.toUpperCase() === 'TFRMALLERGIESEHR')
       this.activateModalAllergies = true 
      else if(this.outComeTemplateCode.toUpperCase() === 'TFMMDNOTEOUTCOMESTUDIES')
       this.activateModalGeneric = true
      else if(this.outComeTemplateCode.toUpperCase() === 'TFRMMDPAINASSESSMENTNOTES')
       this.activeModalPainAssessment = true
      else if(this.outComeTemplateCode.toUpperCase() === 'TFRMMDVITALSIGNSNOTES')
       this.activeModalVitalSign = true
      else if(this.outComeTemplateCode.toUpperCase() === 'TFRMCUSTOMPATIENTMEDICATIONS')
        this.activateModalMedications = true  
    },

    showModalGetLastAnswers() {
      this.showGetLastAnswers = true
    },

    onCancelGetLastAnswers(){
      this.showGetLastAnswers = false
    },

    onOKGetLastAnswers(value) {
      this.Value = value
      this.showGetLastAnswers = false
      this.$emit('input',value);
      this.setChangedStatus()
    },

    handlerClick(evt){
      if(!this.$attrs.control.isReadOnly && !this.isReadOnly) {
        this.$refs.menu.open(evt)
      }
    },

    setValid(state){
        this.style.borderColor = state ? '#dc3545 !important': '#e0e0e0 !important'
    },

    setRequired(value) {
      this.isRequired = value;
      if (!value) {
        this.style.borderColor = '#e0e0e0 !important';
      } else if (this.Value === null || this.Value === undefined || this.Value.length == 0) {
        this.Invalid = true;
        this.style.borderColor = '#dc3545 !important';
      }
    },

    setChangedStatus(){
      var changed = {
        "ControlId":this.$attrs.control.controlID,
        "Changed":true,
        "NoteId":this.NoteId
      }
      EventBus.$emit('onControlWasChanged', changed);
    },

    onEditorReady(editor){
      if (editor.contextMenu) {
        editor.removeMenuItem('cut');
        editor.removeMenuItem('copy');
        editor.removeMenuItem('paste');
      }
      this.isLoadingCkeditor = false
    },

    handleContextMenuSelect: function(args ) {
      if(args.item.id === 'gettenlastans') {
        this.showModalGetLastAnswers()
      }
      if(args.item.id === 'outcome') {
        this.showModal()
      }  
    },

    setValueS2T( sp ){
      let sp2t = ''
      if(this.value) {
        sp2t += Array.from (this.value + ""+sp).join("");
      } else {
        sp2t = Array.from (sp).join("");
      }
      this.Value = sp2t
      this.$emit('input', sp2t);
      this.setChangedStatus()
    },

    onInput(value) {
      this.Value = value;
      this.$emit('input',value)
      this.setChangedStatus()
    },
  },

  created(){
    EventBus.$on("onSetReadOnly", function (e,id) {
      if(this.$attrs.HeaderId === id){
        this.NoteIsVoid = e;
      }
      }.bind(this));
  if(this.$attrs.NoteIsVoid){
    this.NoteIsVoid = this.$attrs.NoteIsVoid;
  }
  EventBus.$on("receivedS2T", function (event) {
      if( event.ControlId == this.$attrs.control.controlID){
        this.setValueS2T( event.finalSentence )
      }
    }.bind(this))
},

  mounted(){
    this.InitializeVariables();
    if (!this.IsCommonPart && this.IsGroupContainer && this.$attrs.control.isCommonControlNote) {
      this.Hint = this.$t('GroupNotesDashboard.ToCompletedInGroupFocus')
    }

    this.$nextTick(() => {
      const ckeditorRef = this.$refs.ckeditorInstance
      const contextRef = this.$refs[`contextMenuBaseForRichEdit_${this.inputElementId}`]
      if (ckeditorRef && contextRef) {
        contextRef.setCKEditorRef(ckeditorRef)
      } else {
        console.warn(`[MdEdit] ⚠️ No se pudo vincular CKEditorRef para ${this.inputElementId}`)
      }
    })
  }
}
</script>

<style>
.scroll{
	overflow: hidden !important;
}

.cke_inner, .cke_wysiwyg_frame, .cke_wysiwyg_div{
  background: transparent !important;
}
.cke_chrome {
  border: 0 !important;
}
</style>